module.exports = __webpack_public_path__ + "img/google_login.e2b41a04.svg";